// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"a1c25132","489":"b594f775","782":"9fbc9775","787":"cad89a62","959":"5cba64d2"}[chunkId] + ".chunk.js";
};